import React from "react";
import PropTypes from "prop-types";
import UserAvatar from "../../atoms/userAvatar";
import UsersFullNameText from "../../atoms/UsersFullNameText";
import { Flex } from "@fluentui/react-northstar";
import { observer } from "mobx-react";

const UserAvatarWithName = observer((props) => {
  const { name, onClick } = props;

  return (
    <Flex
      vAlign="center"
      gap="gap.medium"
      onClick={onClick}
      className="userAvatarWithName clickable"
      data-testid="userAvatarWithName"
    >
      <UserAvatar size="large" />
      <UsersFullNameText content={name} />
    </Flex>
  );
});

UserAvatarWithName.propTypes = {
  name: PropTypes.string,
};

UserAvatarWithName.defaultProps = {
  name: "",
};

export default UserAvatarWithName;
